import React from 'react';
import classnames from 'classnames';
import { Button, Justify } from 'tea-component';
import IconButton from '@gp/components/IconButton';
import GeneralDownloadBtn from '@gp/components/GeneralDownloadBtn';
import UpdateNextMilestone from '@gp/pages/Pipeline/ProjectDetails/Milestone/components/UpdateNextMilestone';
import type { IBaseProps } from '@home/types/common';
import type { IMilestone } from '@gp/pages/Pipeline/ProjectDetails/Milestone/types';
import moment from 'moment';

interface ITopbarProps extends IBaseProps {
  userIsAbleEdit?: boolean;
  editable?: boolean;
  isDownloading?: boolean;
  // 是否仅展示添加Production Milestone按钮
  onlyShowAddBtn?: boolean;
  projectId: string;
  studioId: string;
  stage?: string;
  // 当前project下的Milestone集合
  milestones?: IMilestone[];
  // 当前project的Next Milestone
  nextMilestone?: IMilestone | null;
  // updated日期
  date?: string;
  // 是否全部展开Production Milestones及其Sub Milestones
  allExpand?: boolean;
  milestoneOperationVisible?: boolean;
  // 切换是否全部展开Production Milestones及其Sub Milestones
  toggleAllExpand?: () => void;
  // 添加Production Milestone的回调
  onAdd?: () => void;
  goToUpdatedMilestone?: (id: any) => any;
  // 下载的回调
  onDownload?: () => void;
  // 更新Next Milestone的回调
  onUpdateNextMilestoneSuccess?: (payload: string) => void;
  onUpdateMilestoneOperationVisible?: (payload: boolean) => void;
}

const FOLD_ALL_MILESTONES = 'Fold all Milestones';
const EXPAND_ALL_MILESTONES = 'Expand all Milestones';
const EDIT = 'Edit';
const FINISH_EDITING = 'Finish editing';

const Topbar: React.FC<ITopbarProps> = (props) => {
  const {
    style,
    className,
    userIsAbleEdit,
    editable,
    isDownloading = false,
    onlyShowAddBtn = true,
    projectId,
    studioId,
    stage,
    milestones,
    nextMilestone,
    updatedDate,
    allExpand,
    milestoneOperationVisible = false,
    toggleAllExpand,
    onAdd,
    goToUpdatedMilestone,
    onDownload,
    onUpdateNextMilestoneSuccess,
    onUpdateMilestoneOperationVisible,
  } = props;

  const showUpdatedDate = !onlyShowAddBtn && !!updatedDate?.update_time;

  return (
    <Justify
      style={style}
      className={classnames('dbg-milestone-justify', className)}
      left={
        <>
          {editable && (
            <IconButton type="primary" prefix="cross" onClick={onAdd}>
              Add new Milestone
            </IconButton>
          )}
          {userIsAbleEdit && (
            <UpdateNextMilestone
              projectId={projectId}
              studioId={studioId}
              stage={stage}
              milestones={milestones}
              nextMilestone={nextMilestone}
              onUpdateNextMilestoneSuccess={onUpdateNextMilestoneSuccess}
            />
          )}
          {/* {showUpdatedDate && (
            <span className="dbg-milestone-time">Updated on {date} </span>
          )} */}
          {showUpdatedDate && (
            <span className="dbg-milestone-time">
              {updatedDate?.modify_personnel} updated{' '}
              <span
                className="dbg-milestone-milestone"
                onClick={(e) => {
                  e?.stopPropagation();
                  goToUpdatedMilestone?.(updatedDate?.milestone_id);
                }}
              >
                {updatedDate?.milestone}{' '}
              </span>
              <span className="dbg-milestone-update-time">
                on {moment(updatedDate?.update_time).format('YYYY-MM-DD')}
              </span>
            </span>
          )}
        </>
      }
      right={
        <>
          {!onlyShowAddBtn && (
            <Button
              type="link"
              onClick={(e) => {
                e?.stopPropagation();
                toggleAllExpand?.();
              }}
            >
              {allExpand ? FOLD_ALL_MILESTONES : EXPAND_ALL_MILESTONES}
            </Button>
          )}
          {!onlyShowAddBtn && (
            <>
              <GeneralDownloadBtn
                isLoading={isDownloading}
                isDisabled={false}
                onClick={(e) => {
                  e?.stopPropagation();
                  onDownload?.();
                }}
              />
              {editable && (
                <IconButton
                  className={classnames('dbg-milestone-edit-switch-btn', {
                    large: milestoneOperationVisible,
                  })}
                  type="text"
                  onClick={() => {
                    onUpdateMilestoneOperationVisible?.(
                      !milestoneOperationVisible,
                    );
                  }}
                >
                  {milestoneOperationVisible ? FINISH_EDITING : EDIT}
                </IconButton>
              )}
            </>
          )}
        </>
      }
    />
  );
};

export default Topbar;
